import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import React from "react"
import { t, Trans } from "@lingui/macro"
import WebQuoteForm from "../../../../components/WebQuoteForm/WebQuoteForm"
import { useECommerceMachine } from "../../../_common/machines/machines-context"
import {
    useValidateWebQuoteCommand,
    ValidateWebQuoteCommandState,
} from "../../_common/machines/ecommerce-machine/data-loading/validate-web-quote-command-machine"
import { useBuildPageDataLayer } from "../../_common/tracking/page-data-layer"
import useModal from "../../../../components/ModalProvider/useModal"
import { PageViewAnalytics } from "../../_common/hooks/use-page-view-analytics"
import SendQuoteSectionIntro from "./SendQuoteSectionIntro"
import styles from "./WebQuoteModal.module.scss"

export const isWebQuoteSubmitting = (stateWQ: ValidateWebQuoteCommandState) =>
    stateWQ.matches("loading") || stateWQ.matches("loaded")

type Props = {
    // keep-line
}

const WebQuoteModal: React.FC<React.PropsWithChildren<Props>> = () => {
    const { closeModal } = useModal()
    const [state] = useECommerceMachine()
    const [stateWQ] = useValidateWebQuoteCommand(state)

    state.context.flowVersion.ui.useAutomaticFareSelection()
    state.context.flowVersion.ui.useAutomaticSuiteCategorySelection()

    const activeStep = state.context.flowVersion.tracking.step(state.context.activeStep, "web-quote-form")
    const pageDataLayer = useBuildPageDataLayer(activeStep)
    const isSubmitting = isWebQuoteSubmitting(stateWQ)

    return (
        <Modal
            title={t`Get your summary`}
            size="small"
            modal={{
                isOpen: true,
                onRequestClose: () => {
                    if (isSubmitting) return
                    closeModal("closeWithCallback")
                },
                shouldCloseOnEsc: !isSubmitting,
                shouldCloseOnOverlayClick: false,
            }}
            dataContentName="web-quote-guest-info"
        >
            <ModalBody variant="wide" className={styles.body}>
                <PageViewAnalytics data={pageDataLayer} />
                <SendQuoteSectionIntro />

                <WebQuoteForm formName="send-quote" submitButton={{ content: <Trans>Submit</Trans> }} />
            </ModalBody>
        </Modal>
    )
}

export default WebQuoteModal
